fragment EmailSequenceFragmentSparse on EmailSequence {
    id
    nextUnsentEmail {
        id
        deliveryTime
    }
    messageCount
    sentEmailsCount
    emailSequenceTemplate {
        id
        name
    }
}
